export async function store({}, payload) {
  const data = await this.$frontendRepositories.digitals.store(payload);
  return data;
}
export async function getByUserAndCompany({}, payload) {
  const data = await this.$frontendRepositories.digitals.getByUserAndCompany(payload);
  return data;
}
